export default "__VITE_ASSET__1ff23456__"